import {
    Box,
    SxProps,
    TextField,
    Theme,
    Tooltip,
    useTheme,
} from '@mui/material'
import React, { ChangeEvent, InputHTMLAttributes, MouseEvent } from 'react'
import { useRoundedInputLogic } from '@/shared/hooks'

interface Props {
    placeholder: string
    isCharactersLimit?: boolean
    searchValue: string
    setSearchValue: (value: string) => void
    tooltip?: string | undefined | null
    onChange?: (
        event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => void
    onClick?: (event: MouseEvent<HTMLElement>) => void
    icons?: JSX.Element
    sx?: SxProps<Theme>
    disabled?: boolean
    callback?: () => void
    native?: InputHTMLAttributes<HTMLInputElement>
}

const RoundedInputField = ({
    isCharactersLimit,
    searchValue,
    setSearchValue,
    onChange,
    icons,
    onClick,
    placeholder,
    tooltip,
    sx,
    disabled,
    callback,
    native,
}: Props) => {
    const { showTooltip, inputOnChange } = useRoundedInputLogic(
        setSearchValue,
        onChange,
        isCharactersLimit
    )
    const theme = useTheme()
    const containerStyle = {
        padding: '0 5px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        border: '1px solid',
        borderColor: 'custom.darkGray',
        background: 'none',
        borderRadius: theme.shape.borderRadius,
        height: '35px',
    }

    const textFieldStyle = {
        padding: '0 7px',
        width: '100%',
        typography: 'text2',
        input: {
            color: 'white',
            '&::placeholder': {
                opacity: 1,
                color: 'custom.placeholder',
            },
            '&:focus::placeholder': {
                color: 'transparent',
            },
        },
    }

    return (
        <Box sx={{ ...containerStyle, ...sx }}>
            <Tooltip
                title={tooltip || ''}
                open={!!tooltip && showTooltip && searchValue.length > 0}
                placement="bottom-start"
                disableFocusListener
                disableHoverListener
                disableTouchListener>
                <TextField
                    disabled={disabled}
                    variant="standard"
                    placeholder={placeholder || 'input'}
                    sx={textFieldStyle}
                    value={searchValue}
                    onChange={inputOnChange}
                    onClick={onClick}
                    inputProps={native}
                />
            </Tooltip>
            <Box onClick={callback}>{icons}</Box>
        </Box>
    )
}

export { RoundedInputField }
